import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
    options: {
        textAlign: "left",
        padding: "5px",
        paddingLeft: '10px',
        color: ({ theme }) => theme.palette.text.secondary,
        fontFamily: 'Rubik',
        cursor: 'pointer',
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.05)",
        },
    },

});
